import { render, staticRenderFns } from "./ModalDesempenho.vue?vue&type=template&id=5aa7eabc"
import script from "./ModalDesempenho.vue?vue&type=script&lang=js"
export * from "./ModalDesempenho.vue?vue&type=script&lang=js"
import style0 from "./ModalDesempenho.vue?vue&type=style&index=0&id=5aa7eabc&prod&lang=scss"


/* normalize component */
import normalizer from "!../../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports